export default __webpack_public_path__ + "static/media/offer-time.74121539.png";